{
  "title": "Configuración",
  "description": "Administre la información de su cuenta, seguridad y preferencias",
  "accountInfo": {
    "title": "Información de la Cuenta",
    "accountId": "ID de Cuenta",
    "fullName": "Nombre Completo",
    "email": "Correo Electrónico",
    "country": "País",
    "companyCut": "Tarifas",
    "tenure": "Antigüedad",
    "immutable": "Inmutable",
    "unitedStates": "Estados Unidos",
    "editButton": "Editar",
    "editModal": {
      "title": "Editar Perfil",
      "fullNameLabel": "Nombre Completo",
      "fullNamePlaceholder": "Ingrese su nombre completo",
      "fullNameRequired": "Por favor ingrese su nombre completo",
      "emailLabel": "Correo Electrónico",
      "emailPlaceholder": "Ingrese su correo electrónico",
      "emailRequired": "Por favor ingrese su correo electrónico",
      "emailInvalid": "Por favor ingrese un correo electrónico válido",
      "cancelButton": "Cancelar",
      "saveButton": "Guardar Cambios",
      "success": "Perfil actualizado exitosamente",
      "error": "Error al actualizar el perfil"
    }
  },

  "security": {
    "title": "Seguridad",
    "changePassword": {
      "title": "Cambiar Contraseña",
      "requirements": {
        "title": "Requisitos de Contraseña",
        "minLength": "Al menos 8 caracteres de largo",
        "complexity": "Debe contener al menos 3 de los siguientes: letra minúscula, letra mayúscula, número, carácter especial"
      },
      "currentPassword": {
        "label": "Contraseña Actual",
        "placeholder": "Ingrese contraseña actual",
        "required": "Por favor ingrese su contraseña actual"
      },
      "newPassword": {
        "label": "Nueva Contraseña",
        "placeholder": "Ingrese nueva contraseña",
        "required": "Por favor ingrese una nueva contraseña",
        "minLength": "La contraseña debe tener al menos 8 caracteres"
      },
      "confirmPassword": {
        "label": "Confirmar Nueva Contraseña",
        "placeholder": "Confirme nueva contraseña",
        "required": "Por favor confirme su nueva contraseña",
        "mismatch": "Las contraseñas no coinciden"
      },
      "button": "Cambiar Contraseña",
      "success": "Contraseña cambiada exitosamente",
      "error": "Error al cambiar la contraseña"
    }
  },
  "preferences": {
    "title": "Preferencias",
    "language": {
      "title": "Idioma",
      "english": "English",
      "spanish": "Español",
      "saveButton": "Guardar Idioma",
      "success": "Idioma actualizado exitosamente",
      "error": "Error al actualizar el idioma"
    },
    "emailNotifications": {
      "title": "Notificaciones por Correo",
      "description": "Administre qué notificaciones por correo recibe",
      "masterToggle": "Habilitar todas las notificaciones por correo",
      "profitAllocation": "Asignaciones de ganancias",
      "profitAllocationDesc": "Reciba notificaciones cuando las ganancias se asignen a su cuenta",
      "weeklySettlement": "Liquidaciones semanales",
      "weeklySettlementDesc": "Reciba un resumen semanal de sus liquidaciones y reinversiones",
      "withdrawalStatus": "Actualizaciones de estado de retiro",
      "withdrawalStatusDesc": "Notificaciones sobre cambios en el estado de sus solicitudes de retiro",
      "adminUpdates": "Actualizaciones de administrador",
      "adminUpdatesDesc": "Actualizaciones importantes y anuncios de administradores",
      "saveButton": "Guardar Preferencias",
      "success": "Preferencias de notificaciones actualizadas",
      "error": "Error al actualizar las preferencias de notificaciones"
    }
  },
  "accountManagement": {
    "title": "Administración de Cuenta",
    "closureCancelSuccess": "Solicitud de cierre de cuenta cancelada",
    "closureCancelError": "Error al cancelar la solicitud de cierre",
    "exportData": {
      "title": "Exportar Datos",
      "comingSoon": "Exporte los datos de su cuenta y el historial de transacciones. (Próximamente)"
    }
  },
  "monthlyStatements": {
    "title": "Estados de Cuenta Mensuales",
    "generateNew": "Generar Nuevo Estado de Cuenta",
    "description": "Genere un estado de cuenta mensual detallado que muestre todas las contribuciones, asignaciones de ganancias, liquidaciones y retiros del período seleccionado.",
    "yourStatements": "Sus Estados de Cuenta",
    "generateButton": "Generar Estado de Cuenta",
    "downloadButton": "Descargar",
    "period": "Período",
    "status": "Estado",
    "generated": "Generado",
    "action": "Acción",
    "statusReady": "Listo",
    "statusFailed": "Fallido",
    "statusGenerating": "Generando",
    "generationFailed": "Generación fallida",
    "generatingText": "Generando...",
    "noStatements": "Aún no se han generado estados de cuenta",
    "futureMonthWarning": "No se pueden generar estados de cuenta para meses futuros",
    "generateSuccess": "Estado de cuenta mensual generado exitosamente",
    "generateError": "Error al generar el estado de cuenta",
    "downloadError": "Error al descargar el estado de cuenta",
    "loadError": "Error al cargar los estados de cuenta",
    "months": {
      "january": "Enero",
      "february": "Febrero",
      "march": "Marzo",
      "april": "Abril",
      "may": "Mayo",
      "june": "Junio",
      "july": "Julio",
      "august": "Agosto",
      "september": "Septiembre",
      "october": "Octubre",
      "november": "Noviembre",
      "december": "Diciembre"
    }
  },
  "buttons": {
    "save": "Guardar"
  },
  "messages": {
    "loadError": "Error al cargar los datos del perfil",
    "incomeUpdateSuccess": "Ingreso anual actualizado exitosamente",
    "incomeUpdateError": "Error al actualizar el ingreso anual"
  },
  "privacy": {
    "link": "Política de Privacidad"
  },
  "terms": {
    "link": "Términos y Condiciones"
  }
}
